import React, { Component } from "react";
import listingsData from "./data/listings.json";
import Listing from "./Listing";
import "./Listings.css";

class Listings extends Component {
  render() {
    let rentals = listingsData["for-rent"];
    var rentalCards = rentals.map(rental => {
      return <Listing listingData={rental} />;
    });
    let sales = listingsData["for-sale"];
    var salesCards = sales.map(sale => {
      return <Listing listingData={sale} />;
    });
    return (
      <div>
        <div>
          <div className="divider">
            <hr />
            <div className="listing-group-heading">For Rent</div>
            <hr />
          </div>
          <div className="listings">
            <div className="zillow">
              <a className="zillow-button" target="_blank" href="https://www.zillow.com/b/hayward-place-condominiums-lincoln-ne-5YQnw6/">Listings on Zillow</a>
            </div>
            {rentalCards}
            <div className="disclosure">
              <i>
                Rentals at Hayward Place are individually owned and managed.
                If you are interested in learning more about a unit, please
                reach out to its owner or manager directly using the contact
                information provided on the listing.
                </i>
            </div>
          </div>
        </div>
        {sales.length > 0 && (
          <div>
            <div className="divider">
              <hr />
              <div className="listing-group-heading">For Sale</div>
              <hr />
            </div>
            <div className="listings">{salesCards}</div>
          </div>
        )}
      </div>
    );
  }
}

export default Listings;



// WEBPACK FOOTER //
// ./src/Listings.jsx